const CommonColor = {
  WHITE: "#ffffff",
  BLACK: "#000000",
  RED: "#ff0000",
  GRAY: "#ced4da",
  HEADER_COLOR: "transparent",
  BODY_COLOR: "transparent",
  BOTTOM_COLOR: "transparent",
  DARK: "#343a40",
  TRANS_PARENT: "transparent",
};

export default CommonColor;
